﻿export default class ServicePensionCalculator extends HTMLDivElement {

    constructor() {

        super();

        this.sek = new Intl.NumberFormat('sv-SE', {
            style: 'currency',
            currency: 'SEK',
            maximumFractionDigits: 0
        });

    }

    get calulateButton() {
        return this.querySelector("[data-service-pension-calculator-form-button]");
    }

    get ibb() {
        return this.dataset.servicePensionCalculatorIbb;
    }

    get method() {
        return this.dataset.servicePensionCalculatorMethod;
    }

    get resultElement() {
        return this.querySelector("[data-service-pension-calculator-result]");
    }

    get disclaimerElement() {
        return this.querySelector("[data-service-pension-calculator-disclaimer]");
    }

    set result(value) {
        this.resultElement.innerHTML = "<p>Cirka <span class='resultspan'>" + this.sek.format(value) + "</span> betalas in till din tjänstepension.</p>";
    }

    get salaryElement() {
        return this.querySelector("[data-service-pension-calculator-form-input]");
    }

    get salary() {
        return this.salaryElement.value;
    }

    calculateEventHandler(event) {

        event.preventDefault();

        this.disclaimerElement.classList.add("hidden");
        this.resultElement.classList.add("hidden");

        this.result = this.calculate(this.salary, this.ibb, this.method);

        this.resultElement.classList.remove("hidden");
        this.disclaimerElement.classList.remove("hidden");
    }

    calculate(salary, ibb, method, extra = false) {
        salary = salary.match(/\d+/g).join('');
        if (method == 1) {
            return this.calculateBTP1(salary, ibb);
        } else if (method == 2) {
            return this.calculateBTP2(salary, ibb);
        }
    }

    calculateBTP1(salary, ibb) {
        const percent1 = 0.065;
        const percent2 = 0.32;
        const threshold = (7.5 * ibb) / 12.0;
        const ceiling = (30.0 * ibb) / 12.0;
        return Math.min(salary, threshold) * percent1 + Math.min(ceiling - threshold, Math.max(0, salary - threshold)) * percent2;
    }

    calculateBTP2(salary, ibb) {
        const percent1 = 0.10;
        const percent2 = 0.65;
        const threshold = (7.5 * ibb) / 12.0;
        const ceiling = (20.0 * ibb) / 12.0;
        return Math.min(salary, threshold) * percent1 + Math.min(ceiling - threshold, Math.max(0, salary - threshold)) * percent2;
    }

    testCalculator(...salaries) {
        salaries.map((salary) => {
            console.log("For salary " + salary + " => " + this.sek.format(Math.ceil(this.calculate(salary, this.ibb, this.method))));
        });
    }

    connectedCallback() {
        var calculator = this;
        this.calulateButton.addEventListener("click", function (event) {
            calculator.calculateEventHandler(event)
        });
        // this.testCalculator(25000, 50000, 80000);
    }

}

customElements.define('service-pension-calculator', ServicePensionCalculator, { extends: "div" });